import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../css/notfound.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const [glitchText, setGlitchText] = useState("SEARCHING_SECTOR");

  useEffect(() => {
    const intervals = ["SCANNING_VOID", "ADDRESS_EMPTY", "ROUTE_NOT_FOUND", "UPLINK_STABLE"];
    let i = 0;
    const timer = setInterval(() => {
      setGlitchText(intervals[i % intervals.length]);
      i++;
    }, 200);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="not-found-container">
      <div className="not-found-box">
        <h1>404</h1>
        <div className="status-badge">{glitchText}</div>

        <p className="error-description">
          The requested coordinate does not contain any functional data. The system remains stable, but this sector is currently unmapped.
        </p>

        <div className="log-section">
          <div className="log-line">{`> LOG: SECTOR_EMPTY`}</div>
          <div className="log-line">{`> STATUS: STANDBY`}</div>
          <div className="log-line">{`> SCAN_RESULT: NULL`}</div>
        </div>

        <button
          onClick={() => navigate("/")}
          className="return-button"
        >
          Return to Command Center
        </button>
      </div>

      <div className="not-found-footer">
        Architecture integrity verified. No data lost.
      </div>
    </div>
  );
};

export default NotFound;
